import { render, staticRenderFns } from "./statsCard.vue?vue&type=template&id=75f28110&scoped=true"
import script from "./statsCard.vue?vue&type=script&lang=js"
export * from "./statsCard.vue?vue&type=script&lang=js"
import style0 from "./statsCard.vue?vue&type=style&index=0&id=75f28110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f28110",
  null
  
)

export default component.exports